/* eslint-disable no-console */
/* eslint-disable no-param-reassign */

import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

import { getAccessToken, getRefreshToken, updateTokens } from "context/auth";
import configs from "configs";

const tokenIsExpired = (token) => {
  let result = true;
  try {
    const { exp } = jwt.decode(token);
    result = exp < new Date().getTime() / 1000;
  } catch (err) {
    console.error(err);
  }
  return result;
};

const getUserId = () => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return undefined
  }
  const { id } = jwt.decode(accessToken);
  return id;
}

const api = axios.create({
  baseURL: configs.backendBaseUrl,
});

const authApi = axios.create({
  baseURL: configs.backendBaseUrl,
});

authApi.interceptors.request.use(
  async (config) => {
    let accessToken = getAccessToken();

    if (tokenIsExpired(accessToken)) {
      const refreshToken = getRefreshToken();
      if (!tokenIsExpired(refreshToken)) {
        const { data } = await axios.get(`${configs.backendBaseUrl}/users/refresh`, {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        });
        updateTokens(data.accessToken, data.refreshToken);
        accessToken = data.accessToken;
      } else {
        Swal.fire({
          title: "Authentication expired.",
          didClose: () => {
            window.location = "/sign-in";
          },
        });
      }
    }

    config.headers.common.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (err) => {
    console.error(err);
    return Promise.reject(err);
  }
);

authApi.interceptors.response.use(
  (rsp) => {
    const { data } = rsp;
    if (data.error) {
      Swal.fire(data.error.message);
    }
    return rsp;
  },
  (error) => {
    console.error(error);
    const {
      response: {
        data: {
          error: { message, code },
        },
      },
    } = error;
    Swal.fire(`Error${message ? `: ${message}\n` : ''} [Code: ${code}]`);
    return Promise.reject(error);
  }
);

export { api, authApi, getUserId };
